import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';

import DateRangeService from './date-range';

export const Ng1DateRangeModule = angular
    .module('control-room.shared.services.dateRange', [])
    .factory('crDateRangeService',downgradeInjectable(DateRangeService));
